/**
 * ResponseForm Component
 *
 * Wrapper around DynamicFormGroup for end user advisory response form
 */

import React from 'react';
import DynamicFormGroup from 'components/DynamicFormGroup';

const ResponseForm: React.FC = () => {
  // The DynamicFormGroup will automatically handle:
  // - Fetching form structure from backend (group_id: "enduser-advisory-form")
  // - Rendering appropriate field components
  // - Auto-saving field data to backend
  // - Loading previously saved data for the user

  return (
    <div>
      <DynamicFormGroup group_id="enduser-advisory-form" />
    </div>
  );
};

export default ResponseForm;
